import useShowPWAUpdateToastEffect from "../hooks/useShowPWAUpdateToastEffect";

export function VersionUpdateHandler({
  children
}: {
  children: React.ReactElement;
}) {
  useShowPWAUpdateToastEffect();
  return children;
}
